import React, { useState, useEffect, useRef } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import $ from 'jquery';
import { checkoutAddressClient } from '../../utility/apiClients/appointment-schedule/checkoutAddressClient';
import { setOutsideParamFlag } from "../../reduxStore/appointmentScheduleSlice";
import "./addressSuggestion.css";

function AddressSuggestion({form, validate, errors, handleInput, setIsAddressSelected, disabled, setInvalidAddressError}) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(form.address ? form.address : '');
  const [selectedOption, setSelectedOption] = useState(null);
  const [showOptions, setShowOptions] = useState(true);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [options, setOptions] = useState([]);
  const [preventBlur, setPreventBlur] = useState(false);
  const scrollRef = useRef(null);
  const outsideParamFlag = useSelector((state) => state.appointmentSchedule.outsideParamFlag);  

    useEffect(() => {
      setInputValue(form.address)
    }, [form.address && outsideParamFlag])

  useEffect(() => {

    if (inputValue.length > 3) {
      const timeoutId = setTimeout(() => {
        if(form.address !== inputValue || outsideParamFlag){
          setIsAddressSelected(false);
          (async () => {
            try {
              let response = await checkoutAddressClient({ query: inputValue });
              const getaddressData = response.data.results;
              const options = [];
              let isValidAddressString = false;
                         
              // Address is invalid, no suggestion -- need verbiage 
              if(outsideParamFlag && response.data.count == 1) { // Address is valid, single-suggestion
                let newItm = {
                  address: getaddressData[0].suggestion,
                  format: getaddressData[0].format
                };

                options.push(newItm);
                setOptions(options);

                if(getaddressData[0].suggestion.toLowerCase() !== inputValue.toLowerCase()){
                  setShowOptions(true);
                } else {
                  setActiveSuggestion(0);
                  handleOptionClick(newItm);
                  setShowOptions(false);
                }
                
              } else if (outsideParamFlag && response.data.count == 0) {
                setInvalidAddressError(true);
              }
               else { // Address is valid, multiple suggestions
                getaddressData.map((item) => {
                  let newItm = {
                    address: item.suggestion,
                    format: item.format
                  };
  
                  options.push(newItm);
                });
                setOptions(options);
                setInvalidAddressError(false);
              }

              dispatch(setOutsideParamFlag(false));
            } catch(e){
              console.log("Error checkoutAddressClient : ", e);
            }
          })();
        }
      }, 500);
  
      return () => clearTimeout(timeoutId);
    }
  }, [inputValue]);

  const handleInputChange = (event) => {
    
    setInputValue(event.target.value);
    setPreventBlur(false);
    // Show options when input changes
    setShowOptions(true);
  };

  const handleOptionClick = (option) => {
    localStorage.setItem('EDQValueSelected', 'Yes');
    handleInput(option, true);
    setSelectedOption(option);
    setInputValue(option.address);
    // Prevent hiding the options on click
    setShowOptions(false); 
  };

  const handleBlur = (event) => {
    if(!preventBlur) {
      // Check if the blur event target is within the autocomplete component
      if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
          return;
      }

      if(form.address !== inputValue){
        setIsAddressSelected(false);
      }
      // Prevent hiding the options when clicking outside the component
      setShowOptions(true);
    }
  };

  const handleKeyDown = (e) => {
    /* on ENTER key select the value */
    if (e.keyCode === 13 && showOptions) {
      e.preventDefault();  
      setPreventBlur(true); //to prevent blur event on enter press
      setActiveSuggestion(0);
      handleOptionClick(options[activeSuggestion-1]);  
      setShowOptions(false);
    } 
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      if(activeSuggestion % 3 == 0 && activeSuggestion > 0) {
        scrollRef.current.scrollBy(0, -100);
      }
      $(`ul.suggestions li`).css('background','none');
      $(`ul.suggestions li:nth-child(${activeSuggestion - 1})`).css('background','#F6F6F6');
      setActiveSuggestion(activeSuggestion - 1);
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === options.length) {
        return;
      }
      if(activeSuggestion % 3 == 0 && activeSuggestion > 0) {
        scrollRef.current.scrollBy(0, 100);
      }
      $(`ul.suggestions li`).css('background','none');
      $(`ul.suggestions li:nth-child(${activeSuggestion + 1})`).css('background','#F6F6F6');
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  return (
    <div>
      <input
        id="addressSearch"
        type="text"
        className={`form-control appointment-input ${errors.address ? "input-validated":""}`}
        autoComplete="off"
        value={inputValue}
        onInput={handleInputChange}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder="Enter address"
        required
        disabled={disabled}
        {...validate("address")}
      />
      {errors.address && <p className="invalid-feedback">{errors.address?.message}</p>}
      {showOptions && inputValue && (
        <ul className="suggestions" ref={scrollRef}>
          {options.map((option, index) => {
            let className;

            // Flag the active suggestion with a class
            if (index === activeSuggestion) {
              className = "suggestion-active";
            }

            return (<li className={className} key={index} onClick={() => handleOptionClick(option)} >
              {option.address}
            </li>);
          })}
        </ul>
      )}
    </div>
  );
}

export default AddressSuggestion;